"use client";

import React from "react";
import { Star, MessageCircle, Quote } from "lucide-react";
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  id: 1,
  author: "Alex K.",
  role: "Startup Founder",
  quote: "OceanClaw changed my morning routine. I just text my AI assistant for a daily schedule while I'm making coffee. It's incredibly fast.",
  rating: 5
}, {
  id: 2,
  author: "Sarah L.",
  role: "Senior Researcher",
  quote: "Privacy was my biggest concern with AI. Knowing it's just a private Slack thread gives me total peace of mind for my data.",
  rating: 5
}, {
  id: 3,
  author: "David M.",
  role: "Product Designer",
  quote: "No apps, no logins, no learning curve. It's the first AI tool my parents actually use and love. The simplicity is the feature.",
  rating: 5
}, {
  id: 4,
  author: "James W.",
  role: "Attorney",
  quote: "The legal research capabilities via iMessage are mind-blowing. It's like having a paralegal in my pocket 24/7.",
  rating: 5
}, {
  id: 5,
  author: "Elena R.",
  role: "Operations Lead",
  quote: "We deployed OceanClaw for our internal Slack in minutes. Our team's productivity has spiked without any complex onboarding.",
  rating: 5
}, {
  id: 6,
  author: "Marcus T.",
  role: "Creative Director",
  quote: "Finally, AI that feels like a natural extension of my phone. One text, one instant answer. It's pure technical sophistication.",
  rating: 5
}];
export default function CommunityVoices() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="8439" id="voice-of-the-users" className="relative w-full py-24 overflow-hidden dark bg-background text-foreground">
      {}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-20 left-10 w-64 h-64 bg-primary/10 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-40 right-10 w-80 h-80 bg-primary/5 rounded-full blur-3xl animate-pulse delay-700" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-primary/5 rounded-full blur-3xl" />
        
        {}
        <div className="absolute top-32 right-[15%] opacity-20 animate-bounce duration-[3000ms]">
          <MessageCircle className="w-12 h-12 text-primary" />
        </div>
        <div className="absolute bottom-24 left-[10%] opacity-10 animate-bounce duration-[4000ms]">
          <MessageCircle className="w-16 h-16 text-primary scale-x-[-1]" />
        </div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-4 font-default tracking-tight">
            Voice of the Users
          </h2>
          <p className="text-lg text-muted-foreground font-default">
            Join the growing community of individuals and enterprises unlocking the power of AI with zero friction.
          </p>
        </div>

        <div ref={ref} className={`columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {testimonials.map((testimonial, i) => <div key={testimonial.id} className="break-inside-avoid" data-index={i}>
              <Card className="bg-card border border-border shadow-xl hover:shadow-2xl transition-all duration-300 h-full rounded-xl">
                <CardHeader className="pb-2">
                  <div className="flex gap-1 mb-2">
                    {[...Array(testimonial.rating)].map((_, starIndex) => <Star key={starIndex} className="w-4 h-4 fill-primary text-primary" />)}
                  </div>
                </CardHeader>
                <CardContent className="pb-6">
                  <Quote className="w-8 h-8 text-primary/20 mb-2" />
                  <p className="text-foreground/90 italic font-default text-lg leading-relaxed">
                    "{testimonial.quote}"
                  </p>
                </CardContent>
                <CardFooter className="pt-0 flex flex-col items-start">
                  <span className="font-bold text-foreground text-base font-default">
                    {testimonial.author}
                  </span>
                  <span className="text-sm text-muted-foreground font-default">
                    {testimonial.role}
                  </span>
                </CardFooter>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}